import EFVideo from '@/components/UI/EFVideo';
import Image from '@/components/UI/Image';
import { EFQuestionMark1 } from '@/components/UI/svg/airConditioner';
import EFFacebook from '@/components/UI/svg/crowdfunding/EFFacebook';
import EFInstagram from '@/components/UI/svg/crowdfunding/EFInstagram';
import EFLine from '@/components/UI/svg/crowdfunding/EFLine';
import EFReddit from '@/components/UI/svg/crowdfunding/EFReddit';
import EFTiktok from '@/components/UI/svg/crowdfunding/EFTiktok';
import EFTwitter from '@/components/UI/svg/crowdfunding/EFTwitter';
import EFYoutube from '@/components/UI/svg/crowdfunding/EFYoutube';
import EFAlarmClockIcon from '@/components/UI/svg/Icons/EFAlarmClockIcon';
import EFAvatorIcon from '@/components/UI/svg/Icons/EFAvatorIcon';
import EFRightArrow from '@/components/UI/svg/Icons/EFRightArrow';
import { formatFlow } from '@/constants/crowdfunding';
import { CROWDFUNDING_MEDIA } from '@/constants/link';
import { actIdGetAccessFlow, actIdUpdateAccessFlow } from '@/service/crowdfunding';
import { getSolarRecommand } from '@/service/solar-calculator';
import { handleDynamicPath } from '@/utils/handleDynamicPath';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import dynamic from 'next/dynamic';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

const TAndCModal = dynamic(() => import('./TAndCModal'), { ssr: true });
const PRODUCT_MAP: any = {
    za: {
        productId: 7322399834321,
        variantId: 41834564452561,
    },
};
const SITE_MAP: any = {
    za: 'https://za.ecoflow.com/products/glacier-portable-refrigerator',
};

export default function TopBanner({ activityId, bannerData, activeTab, callBack, isPreOrder, showCalculator, hideBundles = false }: any) {
    const { useLang, useEffect, useState, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('shared');
    const { locale, pathname } = useRouter();
    const {
        swiperImgs,
        subTitle,
        title,
        desc,
        tip,
        days,
        webpUrl,
        showTC,
        showShareLinks = true,
        productKey = '',
        showCountdown = false,
        countdownTime,
        buyNowLink,
        buyNowText,
    } = bannerData;
    const { EFPic } = createEFPic(webpUrl);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { FACEBOOK_COMMUNITY, FACEBOOK, INSTAGRAM, YOUTUBE, TWITTER, REDDIT, TIKTOK, LINE } = CROWDFUNDING_MEDIA[locale] || CROWDFUNDING_MEDIA['us'];
    // 总访问量
    const WAVE_2_TOTAL_VISIT_BASE = 2969750;
    const [totalFlow, setTotalFlow] = useState(0);
    const [product, setProduct] = useState({});

    const onOrderNow = (isPreOrder: any) => {
        if (hideBundles) {
            const link = buyNowLink || SITE_MAP[locale];
            link && window.open(link);
            return;
        }
        activeTab !== 'bundles' && callBack('bundles');
        const targetEl = document.querySelector('.crowdfunding-tabs-nav') as HTMLDivElement;
        const top = targetEl?.offsetTop + targetEl?.offsetHeight || 0;
        window.scrollTo({
            top,
            behavior: 'smooth',
        });
        try {
            // gtm.push({
            //     event: 'uaEvent',
            //     event_name: isPreOrder ? 'click_pre_order' : 'buy',
            //     product_name: title,
            //     position: 'Product EarlyBird',
            // });
            gtm.push({
                event: 'uaEvent',
                event_name: 'click_anchor',
                position: t('crowdfunding.tabs.bundles'),
                button_name: isPreOrder ? t('crowdfunding.header.pre_order') : t('crowdfunding.header.order_now'),
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Donate');
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (activityId) {
            (async () => {
                try {
                    const res = await actIdGetAccessFlow({ activityId });
                    if (res?.code === '0') {
                        setTotalFlow(Math.max(res?.data?.totalFlow, totalFlow));
                    } else {
                        console.error('get access flow failed: ', res?.message);
                    }
                    const resUpdate = await actIdUpdateAccessFlow({ activityId });
                    if (resUpdate?.code !== '0') {
                        console.error('update access flow failed: ', resUpdate?.message);
                    }
                } catch (e) {
                    console.error('access flow failed', e);
                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activityId]);

    const getAsynItem = async (productId: string, variantId: string) => {
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    const discountPrice = FormatMoneyLocal(res?.data?.price || 16999, locale);
                    const originalPrice = FormatMoneyLocal(res?.data?.compareAtPrice || res?.data?.price || 18999, locale);
                    setProduct({
                        discountPrice,
                        originalPrice,
                    });
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const info = PRODUCT_MAP[locale];
        if (hideBundles && info) {
            getAsynItem(info.productId, info.variantId);
        }
    }, []);

    const getDataLayer = (method: string) => {
        return {
            event: 'uaEvent',
            event_name: 'share',
            method,
            item_id: title,
        };
    };

    return (
        <div className={`top-banner ${css.topBanner}`}>
            <div className="title-box">
                {subTitle && <p className="sub-title">{subTitle}</p>}
                {title && <p className="title">{title}</p>}
                {desc && <div className="desc">{desc}</div>}
                {tip && <p className="tip">{tip}</p>}
            </div>
            <div className="left-swiper">
                <Swiper
                    modules={[Navigation, Pagination]}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    initialSlide={0}
                    loop={true}
                    lazy={true}
                    autoplay={false}
                    id="air-swiper"
                    speed={800}
                >
                    {swiperImgs?.map((item: any, indx: number) => {
                        return (
                            <SwiperSlide key={indx}>
                                <div className="swiper-img">
                                    {Array?.isArray(item) ? (
                                        item[0].endsWith('.webm') && item[1].endsWith('.mp4') ? (
                                            <EFVideo
                                                className="fullImgs"
                                                sources={item}
                                                width="100%"
                                                height="100%"
                                                autoPlay
                                                muted
                                                playsInline
                                                preload="auto"
                                                aria-label={title}
                                            />
                                        ) : (
                                            <EFPic name={item} className="fullImgs" alt={title} aria-label={title} />
                                        )
                                    ) : item.endsWith('.mp4') ? (
                                        <video
                                            className="fullImgs"
                                            src={handleDynamicPath(item)}
                                            width="100%"
                                            height="100%"
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            preload="auto"
                                            aria-label={title}
                                        />
                                    ) : (
                                        <Image src={item} className="fullImgs" layout="fill" noUseSrcset alt={title} aria-label={title} />
                                    )}
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            <div className="right-info">
                <div className="active-box">
                    <div className="interested active-item">
                        {!hideBundles && (
                            <>
                                <div className="icon">
                                    <EFAvatorIcon />
                                </div>
                                <div className="number-box">
                                    <p className="number">
                                        {formatFlow(
                                            totalFlow +
                                                (['us', 'ca'].includes(locale) && pathname === '/wave-2-portable-air-conditioner'
                                                    ? WAVE_2_TOTAL_VISIT_BASE
                                                    : 0),
                                        )}
                                    </p>
                                    <div className="number-desc">
                                        <span className="desc-text">{t('crowdfunding.header.interested')}</span>
                                        {showTC && (
                                            <span
                                                className="question"
                                                onClick={() => {
                                                    productKey && setIsModalVisible(true);
                                                    gtm.push({
                                                        event: 'uaEvent',
                                                        event_name: 'activity_hints',
                                                        button_name: 'Question mark',
                                                    });
                                                }}
                                            >
                                                <EFQuestionMark1 />
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                        {hideBundles && (
                            <div className="price">
                                <span className="discountPrice">{product.discountPrice}</span>
                                <span className="originalPrice">{product.originalPrice}</span>
                            </div>
                        )}
                    </div>
                    {['jp'].includes(locale) && (
                        <div className="days active-item">
                            <div className="icon">
                                <EFAlarmClockIcon />
                            </div>

                            <div className="number-box">
                                {showCountdown ? (
                                    <div className="countdown-box">
                                        {countdownTime?.d && (
                                            <p className="number">
                                                {countdownTime?.d}
                                                <span className="days-small">
                                                    {countdownTime?.d === 1 ? t('crowdfunding.bundles.Days') : t('crowdfunding.bundles.Day')}
                                                </span>
                                            </p>
                                        )}
                                        {countdownTime?.h && (
                                            <p className="number">
                                                {countdownTime?.h}
                                                <span className="days-small">
                                                    {countdownTime?.h === 1 ? t('crowdfunding.bundles.Hours') : t('crowdfunding.bundles.Hour')}
                                                </span>
                                            </p>
                                        )}
                                        {countdownTime?.m && (
                                            <p className="number">
                                                {countdownTime?.m}
                                                <span className="days-small">
                                                    {countdownTime?.m === 1 ? t('crowdfunding.bundles.Minutes') : t('crowdfunding.bundles.Minute')}
                                                </span>
                                            </p>
                                        )}
                                        {countdownTime?.s && (
                                            <p className="number">
                                                {countdownTime?.s}
                                                <span className="days-small">
                                                    {countdownTime?.s === 1 ? t('crowdfunding.bundles.Seconds') : t('crowdfunding.bundles.Second')}
                                                </span>
                                            </p>
                                        )}
                                    </div>
                                ) : (
                                    <p className="number">
                                        {days}
                                        <span className="days-small">{days === 1 ? t('crowdfunding.header.day') : t('crowdfunding.header.days')}</span>
                                    </p>
                                )}
                                <p className="number-desc">{t('crowdfunding.header.ends_in')}</p>
                            </div>
                        </div>
                    )}
                </div>
                <div className="btn-box">
                    <button className="btn-order btn" onClick={onOrderNow}>
                        {buyNowText || (isPreOrder ? t('crowdfunding.header.pre_order') : t('crowdfunding.header.order_now'))}
                    </button>
                </div>
                {showCalculator?.link && (
                    <Link className="calculator" href={showCalculator?.link}>
                        <div className="calculator-text">{showCalculator?.btn}</div>
                        <div className="arrow">
                            <EFRightArrow />
                        </div>
                    </Link>
                )}
                {isPreOrder && <p className="preorder-note">{t('crowdfunding.header.preorder_note')}</p>}
                {showShareLinks && (
                    <div className="share-links">
                        {FACEBOOK_COMMUNITY && (
                            <div className="share-link">
                                <Link className="link-media" href={FACEBOOK_COMMUNITY} dataLayer={getDataLayer('Facebook Community')}>
                                    <EFFacebook />
                                </Link>
                            </div>
                        )}
                        {FACEBOOK && (
                            <div className="share-link">
                                <Link className="link-media" href={FACEBOOK} dataLayer={getDataLayer('Facebook')}>
                                    <EFFacebook />
                                </Link>
                            </div>
                        )}
                        {INSTAGRAM && (
                            <div className="share-link">
                                <Link className="link-media" href={INSTAGRAM} dataLayer={getDataLayer('Instagram')}>
                                    <EFInstagram />
                                </Link>
                            </div>
                        )}
                        {YOUTUBE && (
                            <div className="share-link">
                                <Link className="link-media" href={YOUTUBE} dataLayer={getDataLayer('Youtube')}>
                                    <EFYoutube />
                                </Link>
                            </div>
                        )}
                        {TWITTER && (
                            <div className="share-link">
                                <Link className="link-media" href={TWITTER} dataLayer={getDataLayer('Twitter')}>
                                    <EFTwitter />
                                </Link>
                            </div>
                        )}
                        {REDDIT && (
                            <div className="share-link">
                                <Link className="link-media" href={REDDIT} dataLayer={getDataLayer('Reddit')}>
                                    <EFReddit />
                                </Link>
                            </div>
                        )}
                        {TIKTOK && (
                            <div className="share-link">
                                <Link className="link-media" href={TIKTOK} dataLayer={getDataLayer('Tiktok')}>
                                    <EFTiktok />
                                </Link>
                            </div>
                        )}
                        {LINE && (
                            <div className="share-link">
                                <Link className="link-media" href={LINE} dataLayer={getDataLayer('Line')}>
                                    <EFLine />
                                </Link>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {isModalVisible && showTC && <TAndCModal productKey={productKey} callBack={setIsModalVisible} />}
        </div>
    );
}
